import React from 'react';
import { CalendarIcon as DateInputCalendarIcon } from '../../../../ui/Icons';
import './DateInput.css';

/**
 * DateInput Component
 * Reusable date input with calendar icon and presets
 */
const DateInput = ({
  onChange,
  onPresetClick,
  presets = [
    { label: 'Clear date', value: null },
    { label: 'Today', value: 0 },
    { label: 'Tomorrow', value: 1 },
    { label: 'Next week', value: 7 },
  ],
}) => {
  const handleDatePreset = (daysFromNow) => {
    if (daysFromNow === null) {
      onChange(null);
    } else {
      const date = new Date();
      date.setDate(date.getDate() + daysFromNow);
      onChange(date.toISOString().split('T')[0]);
    }
    onPresetClick?.();
  };

  return (
    <>
      <div className="bulk-actions-toolbar__date-presets">
        {presets.map((preset, idx) => (
          <button 
            key={idx}
            className="bulk-actions-toolbar__menu-item" 
            onClick={() => handleDatePreset(preset.value)}
          >
            {preset.label}
          </button>
        ))}
      </div>
      <div className="bulk-actions-toolbar__date-input-row">
        <input
          type="date"
          className="bulk-actions-toolbar__date-input"
          onChange={(e) => onChange(e.target.value || null)}
        />
        <span 
          className="bulk-actions-toolbar__date-input-icon-wrapper"
          onClick={(e) => {
            e.stopPropagation();
            e.currentTarget.previousElementSibling?.showPicker?.();
          }}
        >
          <DateInputCalendarIcon size={14} />
        </span>
      </div>
    </>
  );
};

export default DateInput;
